import { CreateFoodStockFoodItemInFoodStockDTO } from '../models/FoodStockFoodItem'
import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function CreateFoodStockFoodItemCase(
  foodStockRepository: FoodStockRepository
) {
  return async function (data: CreateFoodStockFoodItemInFoodStockDTO) {
    return await foodStockRepository.createFoodStockFoodItem(data)
  }
}
